import { MessageRole } from '../Chat/hooks';
import { AIMessage } from '../Chat/Messages/Message';

export const AI_STREAM_MESSAGE_PREFIX = 'ai_stream_';

export const getDefaultMessage = (
  role: MessageRole,
  content: string = '',
  threadId: string = 'TEMP',
  messageId: string = 'TEMP',
  insertedFrom: 'api' | 'user' = 'user'
): AIMessage => ({
  role,
  content,
  insertedFrom,
  threadId,
  messageId
});
